import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userDetail } from "../../../store/actions/userActions";
import SurveyListHeader from "../../../component/layout/MainHeader";
import SurveyListSidebar from "../../../component/layout/MainSidebar";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import Svg from "../../../component/Svg";
import SearchInput from "../../../core/Inputs/SearchInput";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { formatDate } from "./FormatDate";
import { formatTime } from "./FormatTime";
import { performHttpRequest } from "../../../../axios/PerformHttpRequest";
import style from "../../../views/style.module.css";
import Card from "../../../core/Card";
import debounce from "lodash.debounce";

export default function RoiCustomVariable() {
  const { userData, userFlag } = useSelector((state) => state.userDataHeader);
  let permissions = {};
  if (userData && userData.length > 0) {
    try {
      permissions = JSON.parse(userData[0]?.module_permissions || "{}");
    } catch (error) {
      console.error("Error parsing module_permissions:", error);
    }
  }
  // Define permissions for the module
  const canAdd = permissions?.M1?.add === 1;
  const canEdit = permissions?.M1?.edit === 1;
  const canDelete = permissions?.M1?.del === 1;

  const apiUrl = process.env.REACT_APP_NODE_API_URL;
  const { id } = useParams();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [roiName, setRoiName] = useState("");

  // Get the state props
  const location = useLocation();
  const breadcrumbs =
    location.state || JSON.parse(localStorage.getItem("custom-variable"));

  const getRoiCustomVariableList = async () => {
    try {
      const response = await performHttpRequest(
        "GET",
        `${apiUrl}/roi-custom-variables/list/${id}`,
        ""
      );
      if (
        response.data?.statusCode === 200 &&
        response.data?.result == "success"
      ) {
        console.log("roiId data ", response.data?.data);
        setData(response.data?.data);
      }
    } catch (error) {
      toast.error(error?.response?.data?.responseText);
    }
  };

  useEffect(() => {
    getRoiCustomVariableList();
    // Fetch ROI name for breadcrumbs
    const fetchRoiDetail = async () => {
      try {
        const response = await performHttpRequest(
          "GET",
          `${apiUrl}/roi/getRoiDetail/${id}`,
          ""
        );
        if (response.data?.statusCode === 200 && response.data?.result === "success") {
          setRoiName(response.data.data.roi_name);
        }
      } catch (error) {
        // Optionally handle error
      }
    };
    if (id) fetchRoiDetail();
  }, [id]);

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  const handleEditTemplate = (row, breadcrumbs) => {
    const firstKey = Object.keys(breadcrumbs)[0];
    const props = {
      [firstKey]: "/admin/roi",
      ["Custom Variables"]: `/admin/roi/${id}/custom-variable`,
      [row.roi_custom_variable_name]: ``,
    };
    localStorage.setItem("custom-variable", JSON.stringify(props));
    navigate(
      `/admin/roi/${id}/custom-variable/add/${row.roi_custom_variable_id}`,
      { state: props }
    );
  };

  const columns = [
    {
      width: "300px",
      name: "Variable name",
      sortable: true,
      sortField: "name",
      selector: (row) => row.roi_custom_variable_name,
      cell: (row) => {
        const addDateTime = row?.add_date_time || ""; // Get the published field from the row
        return (
          <>
            <div className="w-100">
              <span className="surv-title">{row.roi_custom_variable_name}</span>
              <div className="modified-text">Added Date Time {addDateTime}</div>
            </div>
          </>
        );
      },
    },

    {
      width: "300px",
      name: "Value",
      sortable: true,
      sortField: "value",
      selector: (row) => row.roi_custom_variable_value,
      cell: (row) => {
        return (
          <>
            <div className="text-center w-100">
              <span className="surv-title">
                {row.roi_custom_variable_value}
              </span>
            </div>
          </>
        );
      },
    },
    {
      name: "Created by",
      selector: "added_by",
      sortable: true,
      sortField: "added_by",
      cell: (row) => {
        return (
          <>
            <div className="text-center w-100">
              <span className="created-text">{row?.name}</span>
            </div>
          </>
        );
      },
    },

    {
      name: "Status",
      selector: "status",
      sortable: true,
      sortField: "status",
      cell: (row) => {
        return (
          <>
            <div className="text-center w-100">
              {row.is_active == 1 ? "Active" : "Inactive"}
            </div>
          </>
        );
      },
    },

    {
      name: "",
      width: "46px",
      cell: (row) => (
        <>
          {canEdit && (
            <div className="dropdown table-dropdown">
              <button
                className="btn dropdown-tgl"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <Svg name="action" />
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                {row?.status !== "publish" && (
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center"
                      type="button"
                      onClick={() => handleEditTemplate(row, breadcrumbs)}
                    >
                      <Svg name="dropdown-edit" />
                      <span className="dropdown-item ms-2">Edit</span>
                    </button>
                  </li>
                )}
                {canDelete && (
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center"
                      data-bs-toggle="modal"
                      data-bs-target="#deletepage"
                      onClick={() => handleDeleteRoiCustomVariable(row)}
                      type="button"
                    >
                      <Svg name="dropdown-delete" />
                      <span className="dropdown-item ms-2">Delete</span>
                    </button>
                  </li>
                )}
              </ul>
            </div>
          )}
        </>
      ),
    },
  ];

  const handleClear = () => {
    setSearchQuery("");
    setFilteredData(data);
  };

  const handleSearch = debounce((inputValue) => {
    setSearchQuery(inputValue);
    if (inputValue.trim() != "") {
      const filteredList = data.filter((item) =>
        item?.roi_custom_variable_name?.toLowerCase().includes(inputValue.toLowerCase())
      );
      setFilteredData(filteredList);
    } else {
      setFilteredData(data);
    }
  }, 300);

  const handleSelectedRowsChange = (rows) => {
    setSelectedRows(rows.selectedRows);
  };

  const conditionalRowStyles = [
    {
      when: (row) => selectedRows.some((r) => r.id === row.id),
      style: {
        backgroundColor: "#F5F5F5",
      },
    },
  ];

  const handleDeleteRoiCustomVariable = (row) => {
    setSelectedRow(row.roi_custom_variable_id);
  };

  const confirmDeleteButton = async () => {
    try {
      let data = {
        roi_custom_variable_id: selectedRow,
      };
      const response = await performHttpRequest(
        "DELETE",
        `${apiUrl}/roi-custom-variables/del`,
        data
      );

      if (response.data?.statusCode === 200) {
        toast.success("Deleted Successfully");
        getRoiCustomVariableList();
      }
    } catch (error) {
      toast.error(error?.response?.data?.responseText);
    }
  };

  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
        <SurveyListHeader />
        <div id="viewport" className="d-flex">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <div className="dashboard-page-outer flex-grow-1">
              <div className="custom-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link
                        to="/admin/roi"
                        className="home-item"
                        title="Dashboard"
                      >
                        Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/admin/roi">Calculator</Link>
                    </li>
                    {roiName && (
                      <li className="breadcrumb-item">
                        <Link to={`/admin/roi/${id}`}>{roiName}</Link>
                      </li>
                    )}
                    <li className="breadcrumb-item active" aria-current="page">
                      <strong>Custom variables</strong>
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="dashboard-page-wrap">
                <div className="table-wrapper-view">
                  <div className="search-filter d-md-flex align-items-center surveyfilter">
                    <div className="flex-grow-1 pe-0 pe-md-3 mb-3 mb-md-0">
                      <SearchInput
                        className="custom-search-input"
                        type="def"
                        view="outlined"
                        color="primary"
                        placeholder="Search"
                        onSearch={handleSearch}
                        onClear={handleClear}
                        fill={true}
                      />
                    </div>
                    {canEdit && (
                      <Link
                        to={`/admin/roi/${id}/custom-variable/add`}
                        className="btn btn-primary add-btn ms-md-2 mt-2 mt-md-0"
                      >
                        <Svg name="plus" /> Create
                      </Link>
                    )}
                  </div>
                  <div className="tablePage bg-white">
                    <div className="content-table survey-table survey-table-height">
                      <div className="data-table-wrap custom-data-table first-check">
                        <DataTable
                          columns={columns}
                          data={filteredData}
                          selectableRows={true}
                          onSelectedRowsChange={handleSelectedRowsChange}
                          pagination
                          onRowSelected={(state) =>
                            handleSelectedRowsChange(state)
                          }
                          selectableRowChecked={(row) =>
                            row.id === selectedRows[0]?.id
                          }
                          conditionalRowStyles={conditionalRowStyles}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="customvar-modal modal custom-modal fade deleteModal"
            id="deletepage"
            tabIndex={-1}
            aria-labelledby="deleteModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <div className={"formcontainer " + style.container}>
                    <div
                      className={
                        "formvawrapper delete-modal-wrap modal-sm " +
                        style.wrapper
                      }
                    >
                      <Card
                        view="raised"
                        className={"formstyle p-0 " + style.card}
                      >
                        <div className="delete-body-wrap delete-language">
                          <div className="heading">
                            <h3>Delete ROI</h3>
                            <p>
                              Are you sure you want to delete ROI Custom
                              Variable ?
                            </p>
                          </div>

                          <div className="button-wrap d-flex justify-content-end">
                            <button
                              type="button"
                              className="btn btn-bordered color-cancel"
                              data-bs-dismiss="modal"
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary ms-3"
                              onClick={confirmDeleteButton}
                              data-bs-dismiss="modal"
                            >
                              Confirm delete
                            </button>
                          </div>
                        </div>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
